import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { Auction, BadDebt, CS, MyAiAnalysis, Mypage } from './data';
import { isLogin } from '../../../utils/auth';
import { useModal } from '../../../context/ModalContext';
interface Props {
  page?: string;
  setOpenMenu: (openMenu: boolean) => void;
}

const MainCategory = [
  '경공매검색',
  '부실채권검색',
  '나만의 AI 경매분석',
  '마이페이지',
  '고객센터',
];
const ServiceList = ({ page, setOpenMenu }: Props) => {
  const [tab, setTab] = useState<string>('경공매검색');
  const { modalDispatch } = useModal();
  const navigate = useNavigate();

  const renderSubCategory = () => {
    if (tab === '경공매검색') {
      return (
        <SubCategoryBox>
          {Auction.map((category, index) => (
            <SubCategoryItem
              key={index}
              onClick={() => {
                navigate(category.url);
                setOpenMenu(false);
              }}
            >
              {category.name}
            </SubCategoryItem>
          ))}
        </SubCategoryBox>
      );
    } else if (tab === '부실채권검색') {
      return (
        <SubCategoryBox>
          {BadDebt.map((category, index) => (
            <SubCategoryItem
              style={{
                opacity: category.url === '' ? 0.2 : 1,
              }}
              key={index}
              onClick={() => {
                navigate(category.url);
                setOpenMenu(false);
              }}
            >
              {category.name}
            </SubCategoryItem>
          ))}
        </SubCategoryBox>
      );
    } else if (tab === '나만의 AI 경매분석') {
      return (
        <SubCategoryBox>
          {MyAiAnalysis.map((category, index) => (
            <SubCategoryItem
              key={index}
              onClick={() => {
                navigate(category.url);
                setOpenMenu(false);
              }}
            >
              <span>
                {category.name}
                {category.name === '퀀트 분석 기반 테마 추천' && <VIP>VIP</VIP>}
              </span>
            </SubCategoryItem>
          ))}
        </SubCategoryBox>
      );
    } else if (tab === '마이페이지') {
      return (
        <SubCategoryBox>
          {Mypage.map((category, index) => (
            <SubCategoryItem
              key={index}
              onClick={() => {
                if (category.name === '관심물건') {
                  sessionStorage.setItem('mypageTab', 'interest');
                }
                if (category.name === '최근 본 물건') {
                  sessionStorage.setItem('mypageTab', 'recent');
                }
                if (category.name === '내 정보 수정') {
                  sessionStorage.setItem('mypageTab', 'myinfo');
                }
                navigate(category.url);
                setOpenMenu(false);
              }}
            >
              {category.name}
            </SubCategoryItem>
          ))}
        </SubCategoryBox>
      );
    } else {
      return (
        <SubCategoryBox>
          {CS.map((category, index) => (
            <SubCategoryItem
              key={index}
              onClick={() => {
                if (category.name === 'FAQ') {
                  window.open(category.url);
                } else if (category.name === '1:1 문의') {
                  modalDispatch('I');
                } else {
                  navigate(category.url);
                }
                setOpenMenu(false);
              }}
            >
              {category.name}
            </SubCategoryItem>
          ))}
        </SubCategoryBox>
      );
    }
  };

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    setOpenMenu(false);
    navigate('/');
  };

  return (
    <Container>
      <MainCategoryBox>
        <MainCategoryInner>
          <div>
            {MainCategory.map((category) => (
              <MainCategoryItem
                key={category}
                active={tab === category}
                onClick={() => {
                  setTab(category);
                }}
              >
                {category}
              </MainCategoryItem>
            ))}
          </div>
          {isLogin() && <LogoutBox onClick={handleLogout}>로그아웃</LogoutBox>}
        </MainCategoryInner>
      </MainCategoryBox>
      {renderSubCategory()}
    </Container>
  );
};

export default ServiceList;

const LogoutBox = styled.div`
  width: 100%;
  padding: 14px 40px 24px 16px;
  color: #616161;
  font-size: 14px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  text-decoration: underline;
  line-height: 20.3px;
  word-wrap: break-word;
  cursor: pointer;
`;

const MainCategoryInner = styled.div`
  width: 100%;
  height: calc(100% - 227px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const Container = styled.div`
  width: 100%;
  height: 100%;
  font-family: Spoqa Han Sans Neo;
  display: flex;
  flex-direction: row;
  border-top: 1px solid #e5e8ea;
  background-color: #f2f5f8;
`;

const MainCategoryBox = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
const MainCategoryItem = styled.span<{ active: boolean }>`
  width: 150px;
  height: 45px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding-left: 16px;
  font-size: 14px;
  font-weight: 500;
  color: ${(props) => (props.active ? '#008AFF' : '#616161')};
  background-color: ${(props) => (props.active ? '#fff' : 'none')};
  cursor: pointer;
`;

const SubCategoryBox = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  background-color: #fff;
`;

const SubCategoryItem = styled.span`
  width: 160px;
  height: 45px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding-left: 12px;
  font-size: 14px;
  font-weight: 500;
  color: #616161;
  cursor: pointer;
  word-break: keep-all;
`;

const VIP = styled.span`
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px 4px;
  color: #ffffff;
  border-radius: 4px;
  font-size: 12px;
  background: linear-gradient(90deg, #008aff, #08c4d5);
`;
